import { MarketplaceCampaignStatus } from '@anytag/graphql';
import { Badge, BadgeProps } from '@anyui/core';

import { useMarketplaceStatusOptions } from '../hooks';

export interface MarketplaceStatusProps {
  className?: string;
  status?: MarketplaceCampaignStatus;
}

export const MarketplaceStatus = ({ status, className }: MarketplaceStatusProps) => {
  const { marketplaceStatusOptions } = useMarketplaceStatusOptions();

  const children = marketplaceStatusOptions.find((o) => o.value === status)?.label || '';
  const statusProps = ((): BadgeProps => {
    switch (status) {
      case MarketplaceCampaignStatus.REVIEWING:
        return { children, color: 'purple' };
      case MarketplaceCampaignStatus.UPCOMING:
        return { children, color: 'blue' };
      case MarketplaceCampaignStatus.ONGOING:
        return { children, color: 'green' };
      case MarketplaceCampaignStatus.SUSPENDED:
      case MarketplaceCampaignStatus.OUT_OF_COUPON:
        return { children, color: 'red' };
      default:
        return { children, color: 'zinc' };
    }
  })();

  return <Badge className={className} {...statusProps} />;
};
